import { createActionTypes } from 'utils/action/actionTypes';

export const FETCH_ALERTS = createActionTypes('FETCH_ALERTS');
export const DOWNLOAD_ALERTS = createActionTypes('DOWNLOAD_ALERTS');
export const SET_SELECTED_ALERT_TYPES = 'SET_SELECTED_ALERT_TYPES';
export const SET_ALERT_REALTIME_ACTIVE = 'SET_ALERT_REALTIME_ACTIVE';

